import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserRole {
  id: number;
  name: string;
}

export interface UserResponse {
  id: string;
  firstname: string;
  lastname: string;
  username: string;
  email: string | null;
  mobile: string;
  dialCode: string | null;
  country: string | null;
  profileImage: string | null;
  referralCode: string;
  isVerified: boolean;
  isSelfRegistered: boolean;
  isBetLocked: boolean;
  status: string;
  roleId: number;
  role: {
    id: number;
    name: string;
  };
  commission: number;
  partnership: number;
  isPartnershipEnabled: boolean;
  passwordChanged: boolean;
  createdAt: string;
  updatedAt: string;
  upline: string;
}

export interface UserState {
  data: UserResponse | null | undefined;
}

const initialState: UserState = {
  data: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserResponse>) {
      state.data = action.payload;
    },
    clearUser(state) {
      state.data = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export const userReducer = userSlice.reducer;
